import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

export const NavSkip = styled.dl<IProps>`
  &.nav-skip {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;

    dt {
      ${mixin.a11y()}
    }

    a {
      position: absolute;
      display: block;
      width: 100%;
      left: 0;
      text-align: center;
      top: -10000px;

      font-size: 16px;

      &:hover,
      &:focus,
      &:active {
        position: absolute;
        top: 0;
        padding: 5px 0;
        font-weight: bold;
        color: #000;
        background: #fff;
      }
    }
  }

  .is-pc {
    display: none;
  }

  @media ${({ theme }) => theme.media.smMax} {
    &.nav-skip {
      a {
        font-size: ${mixin.pxToVw('16')};

        &:hover,
        &:focus,
        &:active {
          padding: ${mixin.pxToVw('5 0')};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .is-mo {
      display: none;
    }

    .is-pc {
      display: block;
    }
  }
`;
